import { getMobileMediaQuery } from "./utils/utils";

export function initHeaderFunctions() {
  if (!getMobileMediaQuery()) return;

  const headerSwitch = document.querySelector(".header__switch") as HTMLDivElement;
  const mobileMenu = document.querySelector(".mobile-menu") as HTMLDivElement;

  headerSwitch.addEventListener("click", () => {
    headerSwitch.classList.toggle("--opened");
    mobileMenu.classList.toggle("--opened");
  });

  mobileMenu.addEventListener("click", (event: PointerEvent) => {
    const target = event.target;

    if (!(target instanceof HTMLElement)) return;

    if (event.target instanceof HTMLAnchorElement) {
      if (headerSwitch.classList.contains("--opened")) {
        headerSwitch.classList.remove("--opened");
        mobileMenu.classList.remove("--opened");
      }
    }

    if (target.closest(".mobile-menu__overlay")) {
      headerSwitch.classList.remove("--opened");
      mobileMenu.classList.remove("--opened");
    }
  });
}
